<script setup lang="ts">
import FileTableEmptyStateIllustration from '@/modules/Workspaces/KnowledgeHub/Files/FileTableEmptyStateIllustration.svg'
import HubAddDataButton from '@/modules/Workspaces/KnowledgeHub/Hubs/HubAddDataButton.vue'
import type { GoogleDriveFile } from '@/modules/Workspaces/KnowledgeHub/Integrations/GoogleDrive/useGoogleDriveConnection'

const emit = defineEmits<{
  'import:computer': [File[]]
  'import:google': [GoogleDriveFile[]]
}>()
</script>

<template>
  <div class="flex h-full flex-col items-center">
    <FileTableEmptyStateIllustration />
    <div class="flex flex-col items-center justify-center gap-3">
      <h2 class="text-xl-18px-bold">This hub is empty</h2>
      <div class="text-center text-sm-12px-light text-text-subtle">
        Looks like this hub has no files uploaded yet. <br />Add data to this hub so you can query
        and interrogate it in a case.
      </div>
      <div class="flex flex-row items-center justify-center gap-2">
        <HubAddDataButton
          @import:computer="emit('import:computer', $event)"
          @import:google="emit('import:google', $event)"
        />
      </div>
    </div>
  </div>
</template>
